package com.eladfinish.bible.contest.screens.pairMatching.usecases

import com.eladfinish.bible.contest.screens.pairMatching.model.SortableData
import io.github.aakira.napier.Napier

class SortableUseCase {

    fun shuffleSortableList(
        pairs: LinkedHashMap<String, String>,
        isAlphabeticalOrderEnabled: Boolean,
    ): List<SortableData<String>> {
        val itemsList = pairs.toList().map {
            SortableData(
                id = it.first.toInt() - 1, // since in spreadsheet it starts from 1
                value = it.second,
            )
        }.run {
            if (isAlphabeticalOrderEnabled) {
                sortedBy { it.value }
            } else {
                randomDerangement()
            }
        }
        Napier.d("itemsList $itemsList")
        return itemsList
    }

    //https://en.wikipedia.org/wiki/Derangement "בלבול"
    private fun <T> List<T>.randomDerangement(): List<T> {
        val shuffled = this.toMutableList()
        val lastIndex = shuffled.lastIndex
        for (i in 0 until lastIndex) {
            val j = (i + 1..lastIndex).random()
            shuffled[i] = shuffled[j].also { shuffled[j] = shuffled[i] }
        }
        return shuffled
    }

}
